import { useMutation, useQueryClient } from 'react-query';
import request from '../../../../../../helpers/request';
import { shutdownAlisaIvrCompanyQuery } from '../../../../shared/api/queries';

const { shutdownAlisaIvrCompanyKey } = shutdownAlisaIvrCompanyQuery;

const changeAlisaState = async ({ shutdownId, data }) => {
  const res = await request.put(
    `/Alert/is_ivr_for_service_company/${shutdownId}`,
    data,
    `Не удалось изменить значения IVR по УК`,
    'Error'
  );

  return res;
};

export const useShutdownAlisaIvrCompanyStateChange = (options = {}) => {
  const queryClient = useQueryClient();

  const changeMutation = useMutation(changeAlisaState, {
    ...options,
    onSuccess: async (res, { shutdownId, data }) => {
      if (res !== 'Error') {
        queryClient.setQueryData(
          shutdownAlisaIvrCompanyKey(shutdownId),
          () => data
        );
      }
    },
  });

  return {
    change: changeMutation.mutateAsync,
    loading: changeMutation.isLoading,
  };
};
